<mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
  <mat-card-header>
    <mat-card-title>
      <h5 class="mb-0"> {{ 'chrage and discharge chart' | translate }} </h5>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div id="chart-wrapper">
      <div id="multiple_yAxis_chart"></div>
    </div>
  </mat-card-content>
</mat-card>